import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "action-list" }
const _hoisted_5 = { class: "dialog-footer" }

import Pagination from '@/components/Pagination.vue'
import { useRouter,useRoute } from 'vue-router'
import { joinParams } from '@/utils/index'
import { useStore } from '@/store/index'
import Keys from '@/constant/key'
import { getCurrentInstance, reactive, ref, onMounted } from 'vue'
import { BrandM } from '@/models/brand'
import { getBrandListApi } from '@/apis/brand'
import SelectBrand from '@/components/SelectBrand.vue'
import { BrandCat } from '@/enums/brand'
import { dateFormat } from '@/utils/index'
import { getProductListAllApi } from '@/apis/product'
    interface productI {
        id:any,
        title:string,
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductGroupEdit',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()

    const store = useStore()
    const today = new Date()
    const filters = reactive({
        start_time:      dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${1}`), 
        end_time:        dateFormat(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`), 
        page:        1,      // 当前页码
        page_size:          10,     // 每页显示条数
    })
    const state =reactive({
        dialogVisible: false,   // 弹框
        group_id: route.query.id || '',
    })
    const productProps = {
        value: 'id',
        label: 'title',
    }
    const groupForm = reactive({
        name: route.query.name || '',
        product_ids:'',
        group_id: route.query.id || '',
    })
    const tableData = ref([])
    const total = ref(0)    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/channel/GroupProductList',{group_id:groupForm.group_id}).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data
        })
    }
    const productList = ref<productI[]>([])

    const onGetProductList = () => {
        getProductListAllApi({}).then((res:any) => {
            const {code, data, msg} = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            productList.value = data
            productList.value.map((item:any) => {
                item.disabled = tableData.value.findIndex((product:any) => product.id == item.id) > -1
            })
        })
    }
    const addProduct = () => {
        state.dialogVisible = true
    }
    const onSubmit = () => {
        if(!groupForm.name) { return proxy.$message({ type: 'error', message: '请输入分组名称' }) }
        if(!groupForm.product_ids) { return proxy.$message({ type: 'error', message: '请选择商品' }) }
        groupForm.product_ids = groupForm.product_ids.length >0 ? groupForm.product_ids.join(',') : ''
        proxy.$http.post('/channel/saveProductGroup', groupForm).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: msg })
            if(groupForm.group_id){
                getList()
            }else{
                router.go(-1)
            }
            onClose()      
        })
   }
   const onClose = () => {
        state.dialogVisible = false
        groupForm.product_ids = ''
    }
   const onDel = (row) => {
        proxy.$http.post('/channel/delProductGroup', { group_id:groupForm.group_id,product_id: row.id }).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: msg })
            getList()
        })
   }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        state.group_id && getList()
        getBrandListApi()
        onGetProductList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!state.group_id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            inline: true,
            model: groupForm,
            class: "form edit-form",
            "label-width": "150px",
            style: {"display":"flex","flex-direction":"column"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "创建组名称",
                style: {"width":"500px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: groupForm.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((groupForm.name) = $event)),
                    placeholder: "请输入组名称",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "商品名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    modelValue: groupForm.product_ids,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((groupForm.product_ids) = $event)),
                    placeholder: "请输入商品名称",
                    multiple: "",
                    filterable: "",
                    clearable: "",
                    style: {"width":"400px"},
                    props: productProps,
                    options: productList.value
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form, { "label-width": "150px" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).go(-1)))
                      }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                          _createTextVNode("取消")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: onSubmit
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createTextVNode("保存")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(groupForm.name), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: addProduct,
            style: {"margin-bottom":"10px","margin-top":"10px"}
          }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("增加")
            ])),
            _: 1
          }),
          _createVNode(_component_el_table, {
            data: tableData.value,
            stripe: "",
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, { type: "index" }),
              _createVNode(_component_el_table_column, {
                prop: "brand_name",
                label: "品牌名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "title",
                label: "商品名称"
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "当前状态"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.status == 1)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: "success"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode("上架")
                        ])),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 1,
                        type: "danger"
                      }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode("下架")
                        ])),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "created_at",
                label: "更新时间"
              }),
              _createVNode(_component_el_table_column, { label: "操作" }, {
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (onDel(scope.row))
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("删除")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode(_component_el_dialog, {
            title: "新增商品",
            modelValue: state.dialogVisible,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.dialogVisible) = $event)),
            width: "30%",
            "close-on-click-modal": false,
            onClose: onClose
          }, {
            footer: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_el_button, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (state.dialogVisible = false))
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("取 消")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("确 定")
                  ])),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_form, {
                model: groupForm,
                "label-width": "100px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "商品名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select_v2, {
                        modelValue: groupForm.product_ids,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((groupForm.product_ids) = $event)),
                        placeholder: "请输入商品名称",
                        multiple: "",
                        filterable: "",
                        clearable: "",
                        style: {"width":"400px"},
                        props: productProps,
                        options: productList.value
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
  ]))
}
}

})